export default {
  layoutTemplate: {
    include_layout_template_compatible_products: true,
    include_layout_template_dimensions: true,
    include_layout_template_paths: true,
    include_layout_template_permission_ids: true,
    include_layout_template_preview: true,
    include_layout_template_publications: true,
  },
}
